import React, { createContext, useContext, useEffect, useState } from "react";
import { apiUrl, authHeaders } from "@/lib/apiConfig";

const AuthContext = createContext(null);

const authError = (message) => {
  const err = new Error(message);
  err.response = { data: { detail: message } };
  return err;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tok = localStorage.getItem("tfu_token");
    if (!tok) { setLoading(false); return; }
    fetch(apiUrl("/auth/me"), { headers: authHeaders() })
      .then((r) => {
        if (!r.ok) throw new Error("Unauthorized");
        return r.json();
      })
      .then((data) => setUser(data))
      .catch(() => localStorage.removeItem("tfu_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await fetch(apiUrl("/auth/login"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw authError(data?.detail || "Autentificare eșuată");
    localStorage.setItem("tfu_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const res = await fetch(apiUrl("/auth/register"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) throw authError(data?.detail || "Înregistrare eșuată");
    localStorage.setItem("tfu_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("tfu_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
